module.exports = __webpack_public_path__ + "img/PXL_20230526_091042012.c53cc24a.jpg";